import store from 'store'
import actions from './actions'
import { PLATFORM_NAME } from '../../config/global'

const STORED_SETTINGS = storedSettings => {
  const settings = {}
  Object.keys(storedSettings).forEach(key => {
    const item = store.get(`app.settings.${key}`)
    settings[key] = typeof item !== 'undefined' ? item : storedSettings[key]
  })
  return settings
}

const initialState = {
  ...STORED_SETTINGS({
    authProvider: 'jwt',
    logo: PLATFORM_NAME,
    locale: 'it-IT',
    isSidebarOpen: false,
    isSupportChatOpen: false,
    isMobileView: false,
    isMobileMenuOpen: false,
    isMenuCollapsed: false,
    menuLayoutType: 'left', // left, top, nomenu
    routerAnimation: 'none',
    menuColor: 'white', // white, dark, gray
    theme: 'default',
    authPagesColor: 'white', // white, gray, image
    primaryColor: '#286090', // '#44d29e',
    leftMenuWidth: 256,
    isMenuUnfixed: false,
    isMenuShadow: true,
    isTopbarFixed: true,
    isGrayTopbar: false,
    isContentMaxWidth: false,
    isAppMaxWidth: false,
    isGrayBackground: true,
    isCardShadow: true,
    isSquaredBorders: false,
    isBorderless: true,
  }),
}

export default function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
